module.exports = __webpack_public_path__ + "static/media/dream-concrete.c650c332.jpeg";